import Modal from './modal';
export { FooterButton, ModalFooter } from './modalRender';
export default Modal;
export * from './interface';